import { ReactNode, useEffect, useRef } from 'react';
import { useAuthStore } from '@store/useAuthStore';
import { refreshAccessToken } from '@api/tokenRefresh';
import { adminsControllerGetMyProfileV1 } from '@api/generated/admin-auth/admin-auth';

type AuthInitializerProps = {
	children: ReactNode;
};

// refresh 토큰 쿠키(httpOnly)로 로그인 세션 복원
const restoreSession = async () => {
	const { login, logout } = useAuthStore.getState();

	try {
		// 인터셉터를 거치지 않는 갱신 요청이라 비로그인 방문 시 에러메시지 제어
		const accessToken = await refreshAccessToken();
		const admin = await adminsControllerGetMyProfileV1();

		login(admin, accessToken);
	} catch {
		logout();
	}
};

// 앱 부팅 시 로그인 세션을 복원 컴포넌트
const AuthInitializer = ({ children }: AuthInitializerProps) => {
	const isInitialized = useRef(false);

	useEffect(() => {
		if (isInitialized.current) return;
		isInitialized.current = true;

		restoreSession();
	}, []);

	return children;
};

export default AuthInitializer;
